import React from 'react';
import { Q, Qdate } from "js/quantum";
import "css/main.scss";
import { UserStatSearchBar } from './manageuser';
import { setCurrentNav } from './common';


export class UsersStatisticsPage extends React.Component {
    static defaultDateRange() {
        return [Qdate.dateFormat(new Date()), Qdate.dateFormat(new Date())];
    }

    constructor(props) {
        super(props);
        this.state = {
            stats: [],
        };
        this.setBind();
    }

    componentDidMount() {
        setCurrentNav('全体统计', this.props.params.id);

        this.search(...UsersStatisticsPage.defaultDateRange());
    }

    setBind() {
        this.search = this.search.bind(this);
    }

    search(start, end) {
        const query = {};
        if (start) {
            query.start = Q.dateStrToUnixTime(start) / 1000;
        }
        if (end) {
            query.end = (Q.dateStrToUnixTime(end) / 1000) + 86400;
        }
        Q.get(`/api/users/statistics`, { query })
        .done((data) => {
            this.setState({
                stats: data.results,
            });
        });
    }

    _renderTr(stat) {
        return (
            <tr key={stat._id}>
                <td><a href={`/user/${stat._id}`} target="_blank">{stat.name}</a></td>
                <td><span>{stat.item.create}</span></td>
                <td><span>{stat.item.typeset}</span></td>
                <td><span>{stat.item.tag}</span></td>
                <td><span>{stat.item.audit}</span></td>
                <td><span>{stat.plan.create}</span></td>
                <td><span>{stat.plan.export}</span></td>
                <td><span>{stat.omega_paper.create}</span></td>
                <td><span>{stat.omega_paper.export}</span></td>
            </tr>
        );
    }

    render() {
        return (
            <div id="user-statistics">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <span>全体统计</span>
                    </div>
                    <div className="panel-body">
                        <div className="search-bar-wrapper">
                            <UserStatSearchBar
                                defaultDateRange={UsersStatisticsPage.defaultDateRange()}
                                searchCallback={this.search}
                            />
                        </div>
                        <div>
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>用户</th>
                                        <th>创建题目</th>
                                        <th>排版题目</th>
                                        <th>标注题目</th>
                                        <th>审核题目</th>
                                        <th>创建教案</th>
                                        <th>导出教案</th>
                                        <th>创建试卷</th>
                                        <th>导出试卷</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { this.state.stats.map(this._renderTr.bind(this)) }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/user/stats.jsx